import axios from "axios";
import React, { useEffect, useState, Component } from "react";
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import ShareButton from "react-web-share-button";

const divStyle = {
    borderColor: 'white',
    backgroundColor:'transparent',
    borderRadius: '50px',
    color: 'white',
    width: '100%',
    textAlign: 'left',
    padding: '0',
   
  };

function Top_selling_products(props) {
 
   
    let history = useHistory();
    const responsive = {
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1,
        },
        tablet: {
            breakpoint: { max: 1024, min: 465 },
            items: 1,
        }
      };
    
    const [product, setProduct] = useState([]);
    const [APIData, setAPIData] = useState([]);
    const [nftCount, setNftCount] = useState(8);
    const loadMoreNft = () => {
        setNftCount(nftCount + 8);
      };




      useEffect(() => {
        const sendGetRequest = async () => {
            try {
                const resp = await axios.get(`https://us-central1-diginoor-3755e.cloudfunctions.net/app/NFT/all`)
                .then((resp) => {
                   // const nftData = response.data;
                    setAPIData(resp.data);
                    console.log(resp.data);
                    
                });
            
            } catch (err) {
                // Handle Error Here
                console.error(err);
            }
        };
        sendGetRequest();
        
    }, []);

    

    return (
        <>
        <div style={{width: '1280px'}} className="top-sellers top-sellers-d">

{APIData.slice(0, 5).map((data) => {
    
    return (
        <div className="top-carrdd">
            <div style={{marginLeft: '12px', width: '244px'}} id="top-card" className={
                data.collection=="Rare" ? "rare-card top-card" 
                : data.collection =="Legendary" ? "legendary-card top-card"
                : data.collection =="Ultimate" ? "ultimate-card top-card" 
                : "top-card"}>
                
                <img src={data.seller} className="lo" />
                <img src={data.film_image} className="lo" />
                <img src={data.seller} className="lo" />
                <div className="ts-dropdown">
               
  <button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
  <div className="dropdown-content" >
  <p><Link to="/contact">Report</Link></p>
  <p><a><ShareButton buttonStyle={divStyle}/></a></p>
  </div>

                </div>
                <div>
{/* <img className="" src={} alt="Logo" /> */}
<Link to={`/nftdetail/${data.id}`}> <img style={{width:'230px'}} src={data.nft_thumb} className="top-im" /></Link>
                </div>
                <div className="top-details">

              {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}  

                <Link to={`/nftdetail/${data.id}`}><p className="top-card-title"> {data.nft_title}</p></Link> 
                <p id="collection" className="top-card-title1">{data.collection}</p>
                <Link to={`/nftdetail/${data.id}`}> <p className="top-card-title-price">${data.price} </p></Link>
              
                
                </div>
                <div style={{left:'213px', top:'-39px'}} className="like">
                <FormControlLabel
        control={<Checkbox icon={<FavoriteBorder />} 
                  checkedIcon={<Favorite />}
          name="checkedH" />}
      />
                </div>
            </div>
           
        </div>
    )
})}
</div>


<div className="top-sellers top-sellers-tb">


{/* <h1 className="thead">TOP SELLERS</h1> */}
<Carousel 
responsive={responsive}
autoPlay={true}
autoPlaySpeed={5000}
infinite={true}
>
{APIData.map((data) => {
return (
<Link to={`/nftdetail/${data.id}`}>
<div  key={data._id} className="top-carrdd">
{/* card1...................................... */}
<div id="top-card" className={
                data.collection=="Rare" ? "rare-card top-card" 
                : data.collection =="Legendary" ? "legendary-card top-card"
                : data.collection =="Ultimate" ? "ultimate-card top-card" 
                : "top-card"}>
    
    <img src={data.seller} className="lo" />
    <img src={data.film_image} className="lo" />
    <img src={data.seller} className="lo" />
    <div className="ts-dropdown">
   
<button className="dropbtn"><i className="glyphicon glyphicon-option-horizontal"></i></button>
<div className="dropdown-content" >
<p><Link to="/contact">Report</Link></p>
<p><ShareButton buttonStyle={divStyle}/></p>
</div>

    </div>
    <div>
{/* <img className="" src={} alt="Logo" /> */}
<Link to={`/nftdetail/${data.id}`}> <img src={data.nft_thumb} className="top-im" /></Link>
    </div>
    <div className="top-details">

  {/*  <a className="top-card-title" href={'/nftfinal/'+data.id}>{data.nft_title}</a>   */}  

    <Link to={`/nftdetail/${data.id}`}><p className="top-card-title"> {data.nft_title}</p></Link> 
    <p id="collection" className="top-card-title1">{data.collection}</p>
    <Link to={`/nftdetail/${data.id}`}> <p className="top-card-title-price">${data.price} </p></Link>
  
    
    </div>
    <div className="like">
    <FormControlLabel
control={<Checkbox icon={<FavoriteBorder />} 
      checkedIcon={<Favorite />}
name="checkedH" />}
/>
    </div>
</div>

</div>
</Link>
)
})}
</Carousel>
</div>
        </>
    )
    
}

export default Top_selling_products